<template>
    <common-page>
        <div class="card" style="min-width: 100%">
            <mini-table ref="adjustTable"
                        class="m-1"
                        :items="scheduledResult.ppdTree"
                        read-only entity-name="projectPlanAdjust"
                        :fields="tableFields"
                        enable-table-tree
                        tree-node-label-name="ppdActivityId"
                        tree-id-name="id"
                        tree-parent-id-name="parentId"
                        without-level break-children
                        disable-first-index-column
                        :default-expend-depth="3"
                        addition-columns="name"
                        custom-columns="isCriticalPath,process"
                        filterable
                        :filter-switch-in-header="viewMode">
                <template #leftHeader>
                    <mini-button variant="outline-warning"
                                 name="Back Old Page"
                                 @btnClick="goBackOldPage">
                        <i class="fa-solid fa-clock-rotate-left"></i>
                        Back
                    </mini-button>
                    <template v-if="!viewMode">
                        <mini-button variant="outline-success" loading-type="grow"
                                     :loading="onSave"
                                     @btnClick="popSaveForm">
                            <i class="fa-solid fa-floppy-disk"></i>
                            Save
                        </mini-button>
                    </template>
                </template>
                <template #custom(process)="{row}">
                    <div class="d-flex flex-column">
                        <b-progress style="width: 80px" variant="info"
                                    :value="row.process" :max="100" show-value></b-progress>
                        <b-progress style="width: 80px; margin-top: 2px" variant="info"
                                    :value="row.projectProgress" :max="100" show-value></b-progress>
                    </div>
                </template>
                <template #custom(isCriticalPath)="{row}">
                    <div class="d-flex flex-column">
                        <!--            关键路径-->
                        <span v-if="row.isCriticalPath" class="badge badge-danger">关键路径</span>
                        <span
                            v-if="row.ppdLastStartTime !== row.ppdOmForecastStartTime || row.ppdLastEndTime !== row.ppdOmForecastEndTime"
                            class="badge badge-warning">上版变动</span>
                        <!--            确认按钮,非自动计算的才有-->
                        <el-button v-if="!row.ppdAutoCalculate" :type="getConfirmButtonType(row)"
                                   icon="el-icon-check"
                                   size="mini" circle style="width: min-content"
                                   @click="handleConfirm(row)"
                        ></el-button>
                    </div>
                </template>
                <template #addition(name)="{row}">
                    <div v-if="!viewMode" class="action-cover">
                        <mini-button variant="light" class="ml-1"
                                     :loading="scheduleLoading"
                                     @btnClick="popAdjustForm(row)">
                            <i class="fa-solid fa-pen-ruler"></i>
                        </mini-button>
                    </div>
                </template>
            </mini-table>
        </div>
        <template #outer>
            <b-modal id="modal-adjust" title="调整计划" hide-footer @hide="scheduleLoading = false">
                <b-form id="form-adjust" @submit="handleAdjustSubmit" @reset="handleAdjustReset">
                    <b-row v-for="adjustRow in adjustRows" :key="adjustRow.name">
                        <b-col sm="3">
                            <label>{{ adjustRow.name }} :</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-textarea v-if="adjustRow.type === 'textarea'" :id="`input-${adjustRow.name}`"
                                             :value="adjustData[adjustRow.key]"></b-form-textarea>
                            <b-form-input v-else :id="`input-${adjustRow.name}`" :type="adjustRow.type"
                                          :value="adjustData[adjustRow.key]"></b-form-input>
                        </b-col>
                    </b-row>
                    <diverse-input-group v-if="needResultItem" ref="inputGroup"
                                         :configs="inputGroupConfigs"></diverse-input-group>
                    <b-row align-h="end" style="margin-top: 30px">
                        <b-form-checkbox v-model="needResultItem" size="lg" switch></b-form-checkbox>
                        <b-button type="submit" variant="primary">
                            排产
                            <b-spinner v-if="scheduleLoading" small></b-spinner>
                        </b-button>
                        <b-button type="reset" variant="danger">取消</b-button>
                    </b-row>
                </b-form>
            </b-modal>
            <b-modal id="modal-save" title="保存项目计划" hide-footer>
                <b-form id="form-save" @submit="handleSaveSubmit" @reset="handleSaveReset">
                    <b-row v-for="saveRow in saveRows" :key="saveRow.name">
                        <b-col sm="3">
                            <label>{{ saveRow.name }} :</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input v-if="saveRow.type !== 'textarea'" :id="`input-${saveRow.name}`"
                                          :type="saveRow.type"
                                          :value="saveData[saveRow.key]"></b-form-input>
                            <b-form-textarea v-else :id="`input-${saveRow.name}`"
                                             :value="saveData[saveRow.key]"></b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row align-h="end" style="margin-top: 30px">
                        <b-button type="submit" variant="primary">保存
                            <b-spinner v-if="onSave" small></b-spinner>
                        </b-button>
                        <b-button type="reset" variant="danger">取消</b-button>
                    </b-row>
                </b-form>
            </b-modal>
        </template>
    </common-page>
</template>
<script>
// Author YuJiaBei
// Date 2021-07-02 15:49:35

import emCommonListMixin from "@/mixin/em/common/list";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emApiMixin from "@/mixin/em/common/api";
import strUtil from "@/utils/strUtil"
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup";
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "ProjectPlanAdjust",
    components: {MiniTable, MiniButton, CommonPage, DiverseInputGroup},
    mixins: [emCommonListMixin, emApiMixin],
    data() {
        return {
            onSave: false,
            isExpandAll: true,
            ganttConfig: {
                // name: "ppdActivityId",
                name: "ppdChineseDescription",
                pid: "parentId",
                startDate: "ppdOmForecastStartTime",
                endDate: "omForecastEndDateWithoutBuffer"
            },
            adjustData: {
                ppdId: 0,
                ppdBufferTime: 0,
                ppdDuration: 0,
                ppdPredecessor: ""
            },
            saveData: {adjustReason: ""},
            adjustRows: [
                {name: "缓冲时间", key: "ppdBufferTime", type: "number"},
                {name: "周期", key: "ppdDuration", type: "number"},
                {name: "前置依赖", key: "ppdPredecessor", type: "textarea"},
            ],
            saveRows: [
                {name: "调整原因", key: "pdsrAdjustReason", type: "textarea"}
            ],
            scheduledResult: {},
            pageType: "list_b",
            inputGroupConfigs: [
                {
                    label: '调整原因类别', name: 'psriReasonType', type: 'select',
                    options: [
                        {value: 1, text: '设计'},
                        {value: 2, text: '数据维护'},
                        {value: 3, text: '采购'},
                        {value: 4, text: '客户'},
                        {value: 5, text: '计划'},
                        {value: 6, text: '其他'},
                    ]
                },
                {label: '调整原因描述', name: 'psriReason', type: 'textarea'},
                {
                    label: '是否影响交期', name: 'psriDelivery', type: 'select',
                    options: [
                        {value: true, text: '是'},
                        {value: false, text: '否'},
                    ]
                },
                {label: '影响交期天数', name: 'psriDeliveryDays', type: 'input', format: 'number'},
                {label: '备注', name: 'remark', type: 'textarea'},
            ],
            needResultItem: false,
            scheduleLoading: false,

            viewMode: false,
            tableFields: [
                {key: 'ppdActivityId', label: '层级'},
                {key: 'projectCode', label: '项目号'},
                {key: 'name', label: '名称'},
                {key: 'forecastStartTime', label: '开始时间', valueFormatter: this.formatter},
                {key: 'forecastEndTime', label: '结束时间', valueFormatter: this.formatter},
                {key: 'isCriticalPath', label: '关键信息'},
                {key: 'ppdDuration', label: '当前周期'},
                {key: 'ppdBaselineEndDeviation', label: '当前差异'},
                {key: 'ppdOmPpStartDeviation', label: '开始时间差异'},
                {key: 'ppdOmPpEndDeviation', label: '完成时间差异'},
                {key: 'process', label: '进度'},
                {key: 'cidPredecessor', label: '前置依赖'},
                {key: 'id', label: 'ppdId'},
                {key: 'ppdPpForecastStartTime', label: '相关开始', valueFormatter: this.formatter},
                {key: 'ppdPpForecastEndTime', label: '相关结束', valueFormatter: this.formatter},
                {key: 'status', label: '状态'},
                {key: 'ppdActualStartTime', label: '实际开始', valueFormatter: this.formatter},
                {key: 'ppdActualEndTime', label: '实际结束', valueFormatter: this.formatter},
                {key: 'actualDuration', label: '实际周期'},
                {key: 'ppdLastStartTime', label: '上版开始', valueFormatter: this.formatter},
                {key: 'omLastEndDateWithoutBuffer', label: '上版结束', valueFormatter: this.formatter},
                {key: 'ppdBaselineBStartTime', label: '基准开始', valueFormatter: this.formatter},
                {key: 'ppdBaselineBEndTime', label: '基准结束', valueFormatter: this.formatter},
                {key: 'baseDuration', label: '基准周期'},
                {key: 'actualDurationDeviation', label: '实际周期差异'},
                {key: 'ppdOmAclStartDeviation', label: '实际开始差异'},
                {key: 'ppdOmAclEndDeviation', label: '实际结束差异'},
                {key: 'mainProjectBeginTime', label: 'MPS开始', valueFormatter: this.formatter},
                {key: 'mainProjectEndTime', label: 'MPS结束', valueFormatter: this.formatter},
                {key: 'mainOmBeginDeviation', label: 'MPS-OM 开始偏差'},
                {key: 'mainOmEndDeviation', label: 'MPS-OM 结束偏差'},
                {key: 'ppdBufferTime', label: 'buffer'},
                {key: 'ppdMilestoneCode', label: '五大支柱编码'},
                {key: 'ppdWbsNumber', label: 'WBS'},
            ]
        }
    },
    computed: {
        modelName() {
            return "sithMesPrdProjectPlanAdjust"
        },
        ganttData() {
            return this.$store.state[this.modelName].rows
        },
        milestoneCodeFilters() {
            let filters = []
            if (this.scheduledResult && this.scheduledResult.ppdMap) {
                let milestoneSet = new Set()
                console.log("计算五大支柱filter")
                Object.values(this.scheduledResult.ppdMap).forEach(value => {
                    milestoneSet.add(value.ppdMilestoneCode)
                })
                milestoneSet.forEach(f => filters.push({text: f, value: f}))
            }
            console.log(filters)
            return filters
        }
    },
    methods: {
        formatter(val) {
            return val ? val.substring(0, 10) : val;
        },
        // getMilestoneCodeFilters(){
        //   let filters = []
        //   if(this.scheduledResult && this.scheduledResult.ppdMap){
        //     let milestoneSet = new Set()
        //     console.log("计算五大支柱filter")
        //     Object.values(this.scheduledResult.ppdMap).forEach(value => {
        //       milestoneSet.add(value.ppdMilestoneCode)
        //     })
        //     milestoneSet.forEach(f => filters.push({text:f,value:f}))
        //   }
        //   console.log(filters)
        //   return filters
        // },
        filterHandler(value, row, column) {
            // console.log("this is filterHandler")
            // console.log(column)
            // console.log(row)
            // console.log(value)
            const property = column['property'];
            return row[property] === value;
        },
        formatDate(row, column) {
            //获取单元格数据
            let data = row[column.property]
            if (data == null) {
                return null
            }
            return strUtil.datetimeStrToDateStr(data)
            // let dt = new Date(data)
            // return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
        },
        // handleQueried(response) {
        //   this.scheduledResult = JSON.parse(JSON.stringify(response.data))
        // },
        tableRowClassName({row, rowIndex}) {
            if (row.startDate === "2021-06-09") {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return 'success-row';
        },
        // handleCurrentChange(currentRow, oldCurrentRow) {
        //   console.log(currentRow.id)
        // },
        popAdjustForm(row) {
            if (this.pageType === "edit_a" || this.pageType === "edit_b") {
                this.adjustData.ppdBufferTime = row.ppdBufferTime
                this.adjustData.ppdDuration = row.ppdDuration
                this.adjustData.ppdPredecessor = row.ppdPredecessor
                this.adjustData.ppdId = row.id
                this.$bvModal.show("modal-adjust")
            }
        },
        popSaveForm() {
            if (this.pageType === "edit_a" || this.pageType === "edit_b") {
                this.saveData.pdsrAdjustReason = ""
                this.$bvModal.show("modal-save")
            }
        },
        handleAdjustSubmit(event) {
            event.preventDefault()
            for (let adjustRow of this.adjustRows) {
                // this.adjustData[adjustRow.key] = formAdjust[`input-${adjustRow.name}`]
                this.adjustData[adjustRow.key] = document.getElementById(`input-${adjustRow.name}`).value
            }
            this.scheduleLoading = true;
            //调用api保存数据
            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi("sithMesPrdProjectPlanDetailPpd")}/adjust`, this.adjustData)
                .then(response => {
                    this.scheduledResult = response.data
                    //为treeData添加翻译为cid的前置依赖
                    this.appendCidPredecessor(this.scheduledResult)
                    //创建计划调整详情
                    if (this.needResultItem) {
                        let inputData = this.$refs.inputGroup.getInputData();
                        inputData.psriIdPpd = this.adjustData.ppdId;
                        this.$store.dispatch('api/post', {
                            url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpdScheduledResultItemPsri/createNoParentRecord",
                            data: inputData
                        }).then(() => commonViewsUtil.showSuccess(this, "调整完成"));
                        this.$nextTick(() => {
                            this.$bvModal.hide('modal-adjust')
                        });
                    } else {
                        commonViewsUtil.showSuccess(this, "调整完成");
                    }
                })
            if (!this.needResultItem) {
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-adjust')
                });
            }
        },
        handleAdjustReset() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-adjust')
            })
        },
        handleSaveSubmit(event) {
            this.onSave = true
            event.preventDefault()
            for (let saveRow of this.saveRows) {
                // this.adjustData[adjustRow.key] = formAdjust[`input-${adjustRow.name}`]
                this.saveData[saveRow.key] = document.getElementById(`input-${saveRow.name}`).value
            }
            //调用api保存数据
            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi("sithMesPrdProjectPlanPrp")}/saveScheduledResult?adjustReason=${this.saveData.pdsrAdjustReason}`, {})
                .then(response => {
                    this.$bvModal.hide('modal-save')
                    //跳转到排产调整页面
                    this.$router.push({name: 'sithMesPrdProjectPlanPrpList', params: {needRefresh: true}})
                    commonViewsUtil.showSuccess(this, "保存成功")
                }).finally(() => this.onSave = false);
            // this.$nextTick(() => {
            //   this.$bvModal.hide('modal-save')
            // })
        },
        handleSaveReset() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-save')
            })
        },
        appendCidPredecessor(scheduledResult) {
            if (scheduledResult && scheduledResult.ppdTree && scheduledResult.ppdTree && scheduledResult.ppdMap) {
                this.appendCidPredecessorRecursion(scheduledResult.ppdTree, scheduledResult.ppdMap)
            }
        },
        appendCidPredecessorRecursion(ppdList, ppdMap) {
            ppdList.forEach(ppd => {
                ppd.cidPredecessor = this.convertPpdIdToCidInPredecessor(ppd, ppdMap)
                if (ppd.children) {
                    this.appendCidPredecessorRecursion(ppd.children, ppdMap)
                }
            })
        },
        /**
         * 翻译前置依赖ppdId为cid
         * @param ppdPredecessor
         * @param ppdMap
         * @returns {string}
         */
        convertPpdIdToCidInPredecessor(ppd, ppdMap) {
            let {ppdPredecessor, reallyEffectivePreDependency} = ppd
            if (!ppdPredecessor) {
                return ""
            }
            // else
            // console.log("ppdPredecessor is",ppdPredecessor)
            //适配中文逗号后，打散成数组
            let predecessorArr = ppdPredecessor.split("，").join(",").split(',')
            let cidPredecessorArr = []
            predecessorArr.forEach(predecessor => {
                predecessor = predecessor.trim()
                let arrPredecessor = predecessor.split(" ")
                // console.log("ppdId is",arrPredecessor[0])
                // console.log("ppd is",ppdMap[arrPredecessor[0]])
                // console.log("cid is",ppdMap[arrPredecessor[0]].ppdActivityId)
                let ppd = ppdMap[arrPredecessor[0]]
                if (ppd && ppd['ppdActivityId'])
                    //如果依赖有多个，把真正生效的依赖的ppdId用【】括起来显示在cid前面，方便调整
                    if (predecessorArr.length > 1
                        && reallyEffectivePreDependency && reallyEffectivePreDependency.targetMissionId) {
                        // console.log("targetMissionId is: ",reallyEffectivePreDependency.targetMissionId,"ppdActivityId is:",arrPredecessor[0])
                        if (arrPredecessor[0] + "" === reallyEffectivePreDependency.targetMissionId + "") {
                            arrPredecessor[0] = `【${arrPredecessor[0]}】${ppd['ppdActivityId']}`
                        } else arrPredecessor[0] = ppd['ppdActivityId']
                    } else arrPredecessor[0] = ppd['ppdActivityId']
                // console.log("cid 2 is",arrPredecessor[0])
                cidPredecessorArr.push(arrPredecessor.join(" "))
            })
            // console.log("cidPredecessorArr is",cidPredecessorArr.join(","))
            return cidPredecessorArr.join(",")
        },
        getConfirmButtonType(row) {
            // 计划完成：ppdOmForecastEndTime，实际完成：ppdActualEndTime
            //如果没有row，或者没有计划开始时间，就直接返回灰色
            if (!row || !row.ppdOmForecastEndTime) {
                return "info"
            }
            //如果有实际完成时间，就说明确认过，就返回绿色
            else if (row.ppdActualEndTime) {
                return "success"
            }
            let currTime = new Date()
            currTime.setHours(0, 0, 0, 0)
            // console.log("currTime is: ",currTime)
            let warningTime = new Date().setDate(currTime.getDate() + 5);
            let dangerTime = new Date().setDate(currTime.getDate());
            //把字符串格式转化为日期类
            let forecastBeginTime = new Date(Date.parse(row.ppdOmForecastEndTime))
            //否则如果计划完成离当前时间还差不到2天了，就红色
            if (forecastBeginTime <= dangerTime) {
                return "danger"
            }
            //否则如果计划完成离当前时间还差不到5天了，就黄色
            else if (forecastBeginTime <= warningTime) {
                return "warning"
            }
            return "info"
        },
        handleConfirm(row) {
            //只有om的list查看，才能confirm计划详情
            if (this.pageType === "list_a") {
                //调用api保存数据
                this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi("sithMesPrdProjectPlanDetailPpd")}/confirm?id=${row.id}`, {})
                    .then(response => {
                        console.log("confirm response is: ", response)
                        row.ppdActualEndTime = response.data.ppdActualEndTime
                        row.ppdActualStartTime = response.data.ppdActualStartTime
                        this.$forceUpdate()
                        commonViewsUtil.showSuccess(this, "调整完成")
                    })
            }
        },

        goBackOldPage() {
            this.$router.push({
                name: 'sithMesPrdProjectPlanAdjust',
                params: {
                    scheduledResult: this.scheduledResult,
                    pageType: this.pageType
                }
            })
        },
    },
    mounted() {
        this.scheduledResult = this.$route.params.scheduledResult ? this.$route.params.scheduledResult : {}
        //为treeData添加翻译为cid的前置依赖
        this.appendCidPredecessor(this.scheduledResult)
        this.pageType = this.$route.params.pageType ? this.$route.params.pageType : "list_b"
        this.viewMode = this.$route.params.readOnly;
    }
}
</script>

<style scoped>
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: yellow;
}

/*隐藏掉小减号按钮*/
/*.app-content >>> .name-col-edit .task-remove {*/
/*  display: none;*/
/*}*/

/*把task-add图标改为小笔*/
.app-content >>> .name-col-edit .el-icon-circle-plus-outline::before {
    content: "\e78c";
}

/*把task-remove图标改为保存*/
.app-content >>> .name-col-edit .el-icon-remove-outline::before {
    content: "\e720";
}

/*.app-content >>> .h-full .name-col-edit >>> .el-icon-circle-plus-outline:before{*/
/*  content: "\E722";*/

/*}*/

.action-cover {
    opacity: 0;
    width: min-content;
    margin-left: auto;
}

.action-cover:hover {
    opacity: 1;
}

:deep(.el-button--mini.is-circle) {
    padding: 3px !important;
}
</style>
